export namespace IpDetectorActions {
	export class GetIp {
		static readonly type = 'Get Ip';
	}
}
